exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".isEmpty{\r\n    text-align: center;\r\n}\r\n\r\n.joinBtn {\r\n    color: #0086f4;\r\n    transition: background-color #fff ease 2s;\r\n    border-radius: 3px;\r\n    border-color: #0086f4;\r\n    font-size: 16px;\r\n    font-weight: 300;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    padding: 9px 24px;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    margin-top: 16px;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.joinBtn:hover {\r\n    background-color: #0086f4;\r\n    color: #fff;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/my-groups/my-groups.component.css
// module id = ../../../../../src/app/components/my-groups/my-groups.component.css
// module chunks = 0